import { useParams, useNavigate } from 'react-router-dom';
import {  FaCheck, FaPhone, FaStar, FaClock, FaShieldAlt } from 'react-icons/fa';
import { useEffect } from 'react';
import MetaTags from '../components/MetaTags';

// Service data with detailed information for each service
const services = {
  'ofis-temizligi': {
    title: 'Ofis Temizliği',
    description: 'Çalışma alanlarınızın hijyenik ve temiz olması için özel ofis temizlik hizmetleri sunuyoruz. Ofislerinizin profesyonel temizliği ile çalışanlarınıza daha sağlıklı bir çalışma ortamı sunun.',
    icon: '🏢',
    article: {
      title: 'Ofis Temizliğinin İş Verimliliğine Etkisi',
      content: [
        'Ofis ortamlarında hijyen ve temizlik, çalışan sağlığı ve iş verimliliği açısından büyük önem taşır. Profesyonel ofis temizliği hizmetlerimizle, çalışanlarınıza daha sağlıklı ve konforlu bir çalışma alanı sunuyoruz.',
        'Ofis temizliğinde en çok dikkat edilmesi gereken noktalar arasında ortak kullanım alanları, tuvaletler, mutfak bölümleri ve çalışma masaları gelir. Ekiplerimiz, bu alanların her birine özel temizlik protokolleri uygulayarak maksimum hijyen sağlar.',
        'Düzenli ofis temizliği, çalışanların hastalıklara yakalanma riskini azaltır, işe devamsızlıkları minimuma indirir ve genel iş verimliliğini artırır.'
      ],
      tips: [
        'Masa üstlerini düzenli olarak dezenfekte edin',
        'Ortak kullanım alanlarını sık sık havalandırın',
        'Klima filtrelerini düzenli olarak değiştirin',
        'Çöp kutularını günlük olarak boşaltın',
        'Ofis zeminlerini günlük olarak süpürün ve haftada en az iki kez yıkayın'
      ]
    },
    features: [
      'Ofis masalarının temizliği',
      'Zemin temizliği ve cilalama',
      'Cam ve pencere temizliği',
      'Mutfak ve dinlenme alanlarının temizliği',
      'Çöp toplama ve atık yönetimi',
      'Klima ve havalandırma ünitelerinin temizliği',
      'Tuvalet ve lavaboların dezenfeksiyonu'
    ],
    price: 'Talep Üzerine',
    duration: '2-6 Saat',
    image: '/images/services/cleaningimage3.jpg',
    whyChooseUs: [
      'Esnek çalışma saatleri',
      'İşletmenizin ihtiyaçlarına özel çözümler',
      'Profesyonel ekip ve ekipmanlar',
      'Haftalık, aylık veya düzenli temizlik programları',
      'İşletmenizin çalışma düzenine uygun planlama'
    ]
  },
  'tadilat-sonrasi': {
    title: 'Tadilat Sonrası Temizlik',
    description: 'Tadilat sonrası oluşan toz, kir ve inşaat atıklarının temizliği için profesyonel hizmet sunuyoruz. Yeni yapılan veya yenilenen mekanlarınızı kullanıma hazır hale getiriyoruz.',
    icon: '🔨',
    article: {
      title: 'Tadilat Sonrası Temizlik Neden Önemlidir?',
      content: [
        'Tadilat sonrası temizlik, inşaat veya yenileme işlemlerinin ardından ortaya çıkan toz, kir ve kalıntıların temizlenmesi işlemidir. Bu özel temizlik türü, standart temizlik işlemlerinden farklı olarak daha kapsamlı ve detaylı bir çalışma gerektirir.',
        'Tadilat sonrası temizlikte öncelikle büyük moloz ve atıklar toplanır, ardından ince toz ve kalıntılar özel ekipmanlarla temizlenir. Son aşamada ise tüm yüzeyler dezenfekte edilerek mekan kullanıma hazır hale getirilir.',
        'Profesyonel tadilat sonrası temizlik hizmeti, hem sağlık açısından güvenli bir ortam sağlar hem de yeni yapılan tadilatın daha uzun ömürlü olmasına yardımcı olur.'
      ],
      tips: [
        'Tadilat öncesinde eşyalarınızı koruyucu örtülerle örtün',
        'Havalandırma sistemlerini kapatın',
        'Tadilat sonrası en az 24 saat boyunca iyi havalandırın',
        'Özellikle elektrik prizleri ve aydınlatma elemanlarını kontrol edin',
        'Kokudan kurtulmak için doğal havalandırma yapın'
      ]
    },
    features: [
      'İnşaat tozu ve kalıntılarının temizlenmesi',
      'Zemin ve duvar temizliği',
      'Cam ve pencere temizliği',
      'Dolap içi ve dışı temizlik',
      'Derin kiri ve yapışkan kalıntıların çıkarılması',
      'Son kontroller ve detaylı temizlik',
      'Kokudan arındırma işlemleri'
    ],
    price: 'Metrekareye Göre',
    duration: '4-8 Saat',
    image: '/images/services/cleaningimage4.jpg',
    whyChooseUs: [
      'Özel ekipmanlar ve profesyonel malzemeler',
      'Deneyimli ve eğitimli ekip',
      'Hızlı ve etkili çözümler',
      'İnşaat sonrası zorlu lekeler için özel yöntemler',
      'Müşteri memnuniyeti garantisi'
    ]
  },
  'yangin-sonrasi': {
    title: 'Yangın Sonrası Temizlik',
    description: 'Yangın sonrası oluşan is, duman ve koku kalıntılarının temizliği için özel yöntemler kullanıyoruz. Mekanınızı tekrar yaşanabilir hale getiriyoruz.',
    icon: '🔥',
    article: {
      title: 'Yangın Sonrası Temizlik Süreci ve Önemi',
      content: [
        'Yangın sonrası temizlik, özel ekipman ve uzmanlık gerektiren zorlu bir süreçtir. Yangının bıraktığı is, duman ve kötü kokular, özel kimyasallar ve teknikler kullanılarak temizlenmelidir. Aksi takdirde bu kalıntılar sağlık açısından risk oluşturabilir.',
        'Profesyonel yangın sonrası temizlik ekibimiz, yangının türüne ve etkilediği alanın büyüklüğüne göre özel temizlik protokolleri uygular. İs ve duman kalıntılarının temizliği için özel solüsyonlar kullanırken, kötü kokuların giderilmesi için ozon tedavisi gibi ileri tekniklerden yararlanılır.',
        'Yangın sonrası temizlik sadece görünür kirliliklerin değil, aynı zamanda havada asılı kalan zararlı partiküllerin de temizlenmesini kapsar. Bu nedenle profesyonel müdahale büyük önem taşır.'
      ],
      tips: [
        'Yangın sonrası alana girmeden önce yetkililerden onay alın',
        'Elektrik ve gaz tesisatlarını kontrol ettirin',
        'Havalandırmayı sağlayın ancak kendinizi riske atmayın',
        'Değerli eşyalarınızı uzmanlara danışarak temizletin',
        'Kurumuş yangın söndürme kimyasallarını temizlemek için profesyonel yardım alın'
      ]
    },
    features: [
      'Duman ve is kalıntılarının temizlenmesi',
      'Kokudan arındırma işlemleri',
      'Yüzeylerin özel solüsyonlarla temizliği',
      'Havalandırma sistemlerinin temizliği',
      'Eşya ve dolapların iç temizliği',
      'Zemin ve duvar temizliği',
      'Son kontroller ve dezenfeksiyon'
    ],
    price: 'Keşif Sonrası',
    duration: '1-3 Gün',
    image: '/images/services/cleaningimage5.jpg',
    whyChooseUs: [
      'Yangın sonrası temizlik konusunda uzman ekip',
      'Özel ekipman ve malzemeler',
      'Hızlı müdahale',
      'Sigorta şirketleri ile çalışma deneyimi',
      'Kapsamlı raporlama'
    ]
  },
  'dis-cephetemizligi': {
    title: 'Dış Cephe & Cam Temizliği',
    description: 'Binaların dış cephe ve cam temizliği için profesyonel çözümler sunuyoruz. Yüksek binalar ve zorlu yüzeyler için özel ekipmanlar kullanıyoruz.',
    icon: '🏙️',
    article: {
      title: 'Dış Cephe ve Cam Temizliğinin Önemi',
      content: [
        'Binaların dış cephe ve cam temizliği, hem estetik görünüm hem de yapısal dayanıklılık açısından büyük önem taşır. Zamanla dış cephelerde biriken kir, toz, egzoz partikülleri ve diğer çevresel faktörler, binanın görünümünü bozduğu gibi yapı malzemelerine de zarar verebilir.',
        'Profesyonel dış cephe temizliği, binanızın ilk günkü görünümüne kavuşmasını sağlarken aynı zamanda uzun vadeli bakım maliyetlerinizi de düşürür. Özel temizlik ekipmanları ve teknikleri kullanılarak yapılan bu işlem, binanızın ömrünü uzatır ve değerini korumasına yardımcı olur.',
        'Cam temizliği ise hem iç mekanlardan daha iyi görüş sağlar hem de doğal ışığın içeri girmesine olanak tanıyarak enerji tasarrufuna katkıda bulunur. Profesyonel cam temizliği, özellikle yüksek binalar için güvenlik önlemleri alınarak yapılmalıdır.'
      ],
      tips: [
        'Dış cephe temizliğini yılda en az iki kez yaptırın',
        'Yağmurdan sonraki günlerde cam temizliği yapmayın',
        'Güneşin dik geldiği saatlerde cam temizliği yapmaktan kaçının',
        'Temizlik sonrası su lekelerini önlemek için yüzeyleri kurulayın',
        'Zorlu hava koşullarında temizlik yapmaktan kaçının'
      ]
    },
    features: [
      'Dış cephe yüzey temizliği',
      'Cam ve pencere temizliği',
      'Kaldırım ve giriş alanı temizliği',
      'Yağmur oluklarının temizliği',
      'Özel kimyasallar ile leke çıkarma',
      'Yüzey koruma uygulamaları',
      'Düzenli bakım programları'
    ],
    price: 'Metrekareye Göre',
    duration: '1-3 Gün',
    image: '/images/services/cleaningimage.jpeg',
    whyChooseUs: [
      'Yüksekte çalışma sertifikalı ekipler',
      'Son teknoloji ekipmanlar',
      'Güvenlik önlemleri',
      'Çevre dostu temizlik ürünleri',
      'Uzun süreli temizlik garantisi'
    ]
  },
};

const ServiceDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const baseUrl = window.location.protocol + '//' + window.location.host;

  // Scroll to top when component mounts or id changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const service = services[id as keyof typeof services];

  if (!service) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <MetaTags 
          title="Hizmet Bulunamadı"
          description="Aradığınız hizmet bulunamadı. Lütfen geçerli bir hizmet seçiniz."
          keywords="hizmet bulunamadı, 404, sayfa bulunamadı"
        />
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Hizmet Bulunamadı</h1>
          <p className="text-xl text-gray-600 mb-8">Aradığınız hizmet şu anda mevcut değil.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <MetaTags 
        title={service.title}
        description={`${service.title} hizmetimiz hakkında detaylı bilgi alın. ${service.description.substring(0, 150)}...`}
        keywords={`${service.title.toLowerCase()}, ${service.title.toLowerCase()} fiyatları, ${service.title.toLowerCase()} hizmeti, profesyonel temizlik, temizlik hizmetleri`}
      />
      <div className="container mx-auto px-4">

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-300 hover:shadow-2xl">
          <div className="md:flex">
            {/* Left Column - Content */}
            <div className="md:w-1/2 p-8 md:p-12 lg:pr-6">
              <div className="flex items-center mb-6">
                <span className="text-5xl mr-4 transform hover:scale-110 transition-transform">{service.icon}</span>
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                  {service.title}
                </h1>
              </div>
              
              <p className="text-gray-600 mb-8 text-lg leading-relaxed">{service.description}</p>
              
              <div className="flex flex-wrap gap-3 mb-8">
                <div className="bg-blue-50 text-blue-800 px-4 py-2.5 rounded-full font-medium flex items-center">
                  <FaClock className="mr-2 text-blue-600" />
                  <span>{service.duration}</span>
                </div>
                <div className="bg-green-50 text-green-800 px-4 py-2.5 rounded-full font-medium flex items-center">
                  <FaStar className="mr-2 text-green-500" />
                  <span>{service.price}</span>
                </div>
              </div>

              <h3 className="text-xl font-semibold mb-4 text-gray-800 border-b pb-2 border-gray-100">Hizmet Kapsamı</h3>
              <ul className="space-y-3 mb-8">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-start group">
                    <div className="bg-green-100 p-1 rounded-full mr-3 mt-0.5 group-hover:bg-green-200 transition-colors">
                      <FaCheck className="text-green-600 text-xs" />
                    </div>
                    <span className="text-gray-700 group-hover:text-gray-900 transition-colors">{feature}</span>
                  </li>
                ))}
              </ul>

              <button 
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold py-3.5 px-6 rounded-xl flex items-center justify-center transition-all duration-300 transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                onClick={(e) => {
                  e.preventDefault();
  
                  // Eğer zaten anasayfadaysak doğrudan scroll yap
                  if (window.location.pathname === '/') {
                    const element = document.getElementById('iletisim');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  } else {
                    // Değilse, doğrudan anasayfadaki iletişim bölümüne yönlendir
                    window.location.href = '/#iletisim';
                  }
                }}
              >
                <FaPhone className="mr-3" /> Hemen Randevu Al
              </button>
            </div>

            {/* Right Column - Image */}
            <div className="md:w-1/2 bg-gradient-to-br from-gray-50 to-gray-100 p-6 md:p-8 lg:p-12 flex items-center justify-center relative overflow-hidden">
              <div className="relative w-full max-w-lg">
                {/* Image with modern shadow and hover effect */}
                <div className="relative rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:scale-[1.02] hover:shadow-2xl">
                  <div className="aspect-w-16 aspect-h-9 w-full">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                  {/* Gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                {/* Why Choose Us Section */}
                <div className="mt-8 bg-white/90 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-gray-100 transform transition-all duration-300 hover:shadow-xl">
                  <h3 className="text-xl font-semibold mb-4 text-gray-800 flex items-center">
                    <FaShieldAlt className="text-blue-500 mr-2" />
                    Neden Bizi Tercih Etmelisiniz?
                  </h3>
                  <ul className="space-y-3">
                    {service.whyChooseUs.map((item, index) => (
                      <li key={index} className="flex items-start group">
                        <div className="bg-blue-50 p-1 rounded-full mr-3 mt-0.5 group-hover:bg-blue-100 transition-colors">
                          <FaShieldAlt className="text-blue-500 text-xs" />
                        </div>
                        <span className="text-gray-700 group-hover:text-gray-900 transition-colors">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                
              </div>
            </div>
          </div>
        </div>

        {/* Article Section */}
        {service.article && (
          <div className="mt-16 bg-white rounded-2xl shadow-lg p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">{service.article.title}</h2>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
              {service.article.content.map((paragraph, index) => (
                <p key={index} className="text-lg">{paragraph}</p>
              ))}
            </div>

            {service.article.tips && (
              <div className="mt-10 bg-blue-50 rounded-xl p-6">
                <h3 className="text-xl font-semibold text-blue-800 mb-4 flex items-center">
                  <FaCheck className="mr-2 text-blue-600" />
                  İpuçları & Öneriler
                </h3>
                <ul className="space-y-3">
                  {service.article.tips.map((tip, index) => (
                    <li key={index} className="flex items-start">
                      <span className="text-blue-500 mr-2 mt-1">•</span>
                      <span className="text-gray-800">{tip}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="mt-10 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-8 text-center">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Profesyonel Destek Almak İster misiniz?</h3>
              <p className="text-gray-700 mb-6">Uzman ekibimiz, {service.title.toLowerCase()} konusundaki tüm ihtiyaçlarınız için burada. Hemen iletişime geçin, size en uygun çözümü birlikte belirleyelim.</p>
              <button 
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-xl transition-colors duration-300 inline-flex items-center"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.location.pathname === '/') {
                    const element = document.getElementById('iletisim');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  } else {
                    window.location.href = '/#iletisim';
                  }
                }}
              >
                <FaPhone className="mr-2" /> Hemen Teklif Alın
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceDetail;
